import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import TitleSection from "../Components/TitleSection";
import { LinkAndCancelButton, STEPS } from "../utils";
import Container from "../Components/Container";
import EventSummary from "../Components/EventSummary";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { useRescheduling } from "../ReschedulingProvider";

export default function MakeupDay() {
  const { t } = useTranslation(["rescheduling"]);
  const { setStep, setNewAppointmentTime, clientMakeupDays } = useRescheduling();
  return (
    <Container showGoHome>
      <TitleSection
        title={t("rescheduling:common.needToChangeSession")}
        subtitle={t("rescheduling:makeupDay.subtitle")}
      />
      <Stack gap={7}>
        <EventSummary
          HighligthIcon={ArrowsClockwise}
          highlightText={t("rescheduling:common.makeupDay")}
          eventDate={clientMakeupDays[0]}
          onUpdate={() => {
            setNewAppointmentTime(clientMakeupDays[0]);
            setStep(STEPS.review);
          }}
        />
        <LinkAndCancelButton
          LinkLabel={t("rescheduling:makeupDay.viewMoreRescheduleTimes")}
          onClickLink={() => setStep(STEPS.recommendations)}
          onCancel={() => setStep(STEPS.cancellationReview)}
        />
      </Stack>
    </Container>
  );
}
